import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { defaultLogo } from "../../../env";
import { CopyIcon, DeleteIcon, ShareIcon } from "../../../iconshere";
import { LiveIcon, PreviewIcon } from "../../../assets/SvgIcons";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { getNameInitials } from "../../../utils";

const ProjectCard = ({ projectData, showDashboard, handleEnableShareProject, confirmMoveToTrash }) => {
  const navigate = useNavigate();
  let thumbnail = "";
  const roletypeList = projectData.allocations?.map((item) => item.type);
  let roleType = "VIEWER";
  if (roletypeList.includes("OWNER")) {
    roleType = "OWNER";
  }
  if (roletypeList.includes("EDITOR")) {
    roleType = "EDITOR";
  }

  if (Array.isArray(projectData.scenes) && projectData.scenes.length > 0) {
    thumbnail = projectData.scenes[0].inventory.path;
  }

  return (
    <div className="project-item" onClick={() => navigate(`/projects/edit/${projectData.uuid}`)}>
      <div className={thumbnail ? "img-wrapper " : "img-wrapper default"}>
        {thumbnail ? (
          <img
            src={thumbnail}
            onError={(e) => {
              e.target.src = { defaultLogo };
            }}
          />
        ) : (
          <img src={defaultLogo} />
        )}
      </div>
      <div className="detail-sec">
        <div className="name-info">
          <div className="name-date">
            <p className="name" title={projectData.name}>
              {projectData.name}
            </p>
            <span className="date">Created at {moment(projectData.createdAt).format("DD MMM YYYY")}</span>
          </div>
          {!showDashboard && roleType !== null && roleType !== "VIEWER" && (
            <div className="dropdown-wrapper" onClick={(e) => e.stopPropagation()}>
              <div className="userdrop">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <div className="options">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-three-dots-vertical"
                        viewBox="0 0 16 16"
                      >
                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                      </svg>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="sidebartopbar modulelistoptions">
                    <div className="listoptionsmodule">
                      {roleType === "OWNER" && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            confirmMoveToTrash(projectData.uuid, "TRASH");
                          }}
                        >
                          <DeleteIcon />
                          Move to trash
                        </span>
                      )}
                      {projectData.preview && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(`/preview/project/${projectData.uuid}`);
                          }}
                        >
                          <PreviewIcon />
                          Preview
                        </span>
                      )}
                      {projectData.published && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(`/view/project/${projectData.uuid}`);
                          }}
                        >
                          <LiveIcon />
                          Live View
                        </span>
                      )}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEnableShareProject(projectData);
                        }}
                      >
                        {" "}
                        <ShareIcon /> Share Project{" "}
                      </span>

                      {roleType === "OWNER" && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            confirmMoveToTrash(projectData.uuid, "CLONE");
                          }}
                        >
                          {" "}
                          <CopyIcon /> Clone{" "}
                        </span>
                      )}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          )}
        </div>
        <div className="owner-detail">
          {projectData?.owner &&
            (projectData?.owner?.avatar ? (
              <img src={projectData.owner.avatar} referrerPolicy="no-referrer" />
            ) : (
              <span className="initial"> {getNameInitials(projectData?.owner?.name || "")} </span>
            ))}
          <p className="user-name"> {projectData?.owner?.name || ""} </p>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
